import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Noise } from "@/components/Noise";
import { Field, inputCls } from "@/components/FormKit";
import { Button } from "@/components/ui/button";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user && user.role) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) {
      toast.success("Welcome back");
      navigate("/admin", { replace: true });
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div data-testid="login-page" className="min-h-screen flex items-center justify-center bg-secondary/40 px-5">
      <Noise />
      <div className="w-full max-w-md">
        <div className="mb-8">
          <span className="font-display text-2xl tracking-mega">FaeVor</span>
          <span className="ml-2 text-xs uppercase tracking-[0.25em] text-primary font-semibold">Works</span>
        </div>
        <form onSubmit={onSubmit} data-testid="login-form" className="rounded-3xl border border-border bg-card p-8 sm:p-10">
          <h1 className="font-display text-3xl tracking-tight">Admin sign in</h1>
          <p className="text-foreground/60 mt-2 text-sm">Access the FaeVor Works leads dashboard.</p>
          <div className="mt-8 space-y-6">
            <Field label="Email" htmlFor="login-email">
              <input id="login-email" data-testid="login-email" type="email" required className={inputCls}
                value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@faevorworks.com" />
            </Field>
            <Field label="Password" htmlFor="login-password">
              <input id="login-password" data-testid="login-password" type="password" required className={inputCls}
                value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
            </Field>
          </div>
          <Button
            type="submit"
            data-testid="login-submit"
            disabled={busy}
            className="mt-9 w-full rounded-full bg-primary text-primary-foreground py-6 text-base font-semibold hover:bg-primary/90"
          >
            {busy ? "Signing in..." : "Sign In"}
          </Button>
        </form>
      </div>
    </div>
  );
}
